<template>
  <v-container fluid>
    <h1 class="display-inline">Scheduling</h1>
    <div class="display-inline ml-3">
      <ActiveApiCalls/>
    </div>
    <StaffQuestion></StaffQuestion>
    <WeeklyPlan :showStaffNavigator="false"/>
  </v-container>
</template>

<script>


import WeeklyPlan from "@/components/capacity/WeeklyPlan.vue"
import ActiveApiCalls from "@/components/tools/ActiveApiCalls.vue";
import StaffQuestion from "@/components/capacity/StaffQuestion.vue";

export default {
  name: "StaffPlanSchedulePage",
  permissions: [...StaffQuestion.permissions, ...WeeklyPlan.permissions],
  components: {ActiveApiCalls, StaffQuestion, WeeklyPlan},
  data() {
    return {}
  },
}

</script>

<style scoped>

</style>
